export default "__VITE_ASSET__IqR_BDm0__"